module.exports = __webpack_public_path__ + "static/img/logo.f4b491a6.svg";